import { mq, Skeleton as _Skeleton } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DETAIL_HEADER_ASPECT_RATIO = 56.25;

export const DivMaxWidth = styled.div`
  max-width: 1024px;
  margin: auto;
`;

export const DivSkeletonRoot = styled.div`
  width: 100%;
  overflow: hidden; // MEMO（kimura）: スケルトン表示中にモーダル内部をスクロールできないようにするため
  min-height: calc((var(--vh, 1vh) * 100) - 48px);

  ${mq.sp} {
    min-height: calc((var(--vh, 1vh) * 100));
  }
`;

export const SampleAssetSkeleton = styled(_Skeleton)`
  padding-bottom: ${DETAIL_HEADER_ASPECT_RATIO}%;
`;
